import Navbar from "../components/nav";
import { Icon } from "@iconify/react";
import "../css/jobs.css";
import { Helmet } from "react-helmet";
import logo1 from "../media/favIcon.png";
import logo2 from "../media/whiteFav.png";
import Swal from "sweetalert2";
import man from "../media/undraw_in-the-office_e7pg.svg";
import axios from "axios";
import "../css/jobsresp.css";
import "../css/landing.css";
import useStore from "../store/zustandstore";
import "../css/landingresp.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import usefbStore from "../store/firebasestore";

function Jobs() {
  const navigate = useNavigate();
  const jobArray = usefbStore((s) => s.jobArray);
  const leftUI = useRef(null)
  const rightUI = useRef(null)
  const authStatus = usefbStore((s) => s.authStatus);
  const userID = usefbStore((s) => s.userID);
  const closeFonMenu = useStore((s) => s.closeFonMenu);
  const fonMenuDrawer = useStore((s) => s.fonMenuDrawer);
  const solaraTokens = usefbStore((s) => s.solaraTokens);
  const hideScreenLoader = useStore((s) => s.hideScreenLoader);
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]); // ✅ New state for filtered jobs
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search term state
  const [SelectedJob, setSelectedJob] = useState(null);
  const [newsolaraTokens, setSolaraTokens] = useState(0);

  useEffect(() => {
    if (!jobArray?.length) {
      return;
    }
    setJobs(jobArray);
    setFilteredJobs(jobArray); // ✅ Initialize filtered jobs
  }, [jobArray]);

  // ✅ Search filter function
  useEffect(() => {
    if (!jobs.length) {
      setFilteredJobs([]);
      return;
    }
    
    if (searchTerm.trim() === "") {
      setFilteredJobs(jobs);
    } else {
      const filtered = jobs.filter(job => 
        job.jobName?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredJobs(filtered);
      
      // ✅ If selected job is no longer in filtered results, clear selection
      if (SelectedJob && !filtered.find(job => job.id === SelectedJob.id)) {
        setSelectedJob(null);
      }
    }
  }, [searchTerm, jobs, SelectedJob]);

  const cnclFon = () => {
    closeFonMenu();
  };

  useEffect(() => {
    if (authStatus == "unauthenticated") navigate("/auth");
         if(authStatus==="authenticated"){
           
         }

  }, [authStatus]);

  const applyJob = () => {
    if (solaraTokens == null) return;

    if (solaraTokens < 10) {
      Swal.fire({
        title: "Insufficient Tokens",
        html: `
          <div style="text-align: center;">
            <p style="font-size: 16px; margin-bottom: 10px;">You need <strong style="color: #6a5acd;">10 Tokens</strong> to apply for this job. Your current balance: <strong>${solaraTokens} Tokens</strong></p>
          </div>
        `,
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: "Add Tokens",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#6a5acd",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/redeemtokens");
        }
      });
    } else {
      // Step 1: Confirm application
      Swal.fire({
        title: "Confirm Application",
        html: `
          <div style="text-align: center;">
            <p>You are about to apply for a job.</p>
            <p style="margin-top: 10px;">This will cost <strong style="color: #6a5acd;">10 Tokens.</strong> Your current balance: <strong>${solaraTokens} Tokens</strong></p>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          // Step 2: Upload CV
          Swal.fire({
            title: "Upload Your CV",
            html: `
              <div style="text-align: left;">
                <p style="margin-bottom: 8px; font-weight: 500;">Upload your CV (PDF or DOCX):</p>
                <input type="file" id="cvFile" accept=".pdf,.docx" style="width: 100%; padding: 8px; margin-top: 5px; border: 1px solid #ccc; border-radius: 5px;" />
                <p style="font-size: 12px; color: #666; margin-top: 8px;">Maximum file size: 5MB</p>
              </div>
            `,
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Submit",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            confirmButtonColor: "#6a5acd",
            cancelButtonColor: "#d33",
            preConfirm: () => {
              const fileInput = document.getElementById("cvFile");
              const file = fileInput.files[0];

              if (!file) {
                Swal.showValidationMessage("Please select a CV file");
                return false;
              }

              const validTypes = [
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              ];
              if (!validTypes.includes(file.type)) {
                Swal.showValidationMessage("Please upload a PDF or DOCX file");
                return false;
              }

              return { file };
            },
          }).then(async (uploadResult) => {
            if (uploadResult.isConfirmed) {
              const file = uploadResult.value.file;

              Swal.fire({
                title: "Processing",
                text: "Submitting your application...",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });

              try {
                const formData = new FormData();
                formData.append("cv", file);
                formData.append("jobId", SelectedJob.id);
                formData.append("userId", userID);

                const response = await axios.post(
                  "https://solaraback-g1bm.onrender.com/apply-job",
                  formData
                );

                if (response.data.status === "success") {
                  setSolaraTokens(solaraTokens - 10);

                  Swal.fire({
                    title: "Application Submitted",
                    text: "Your job application has been submitted successfully.",
                    icon: "success",
                    confirmButtonColor: "#6a5acd",
                  });
                }
              } catch (error) {
                Swal.fire({
                  title: "Submission Failed",
                  text: "Something went wrong. Please try again.",
                  icon: "error",
                  confirmButtonColor: "#6a5acd",
                });
              }
            }
          });
        }
      });
    }
  };

  
  const backtoList= ()=>{
        if(window.innerWidth <= 992){

    leftUI.current.style.position="absolute"
    leftUI.current.style.left="0%"
    rightUI.current.style.position="absolute"
    rightUI.current.style.right="-110%"
        }
  }
  const viewJob = (jobId) => {
    if(window.innerWidth <= 992){
    leftUI.current.style.position="absolute"
    leftUI.current.style.left="-110%"
    rightUI.current.style.position="absolute"
    rightUI.current.style.right="0%"
    }


    const job = filteredJobs.find((job) => job.id === jobId);
    if (job) {
      setSelectedJob(job);
    }
  };
  
  const toAuth = () => {
    navigate("/auth");
  };

  // ✅ Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="JobsPage">
      <Helmet>
        <title>Freelance Work Opportunities</title>
        <meta
          name="description"
          content="Browse remote AI tasks and freelance jobs on Solara. Find paid work opportunities, complete tasks, and earn money online."
        />
      </Helmet>
      <div className={`fonMenu ${fonMenuDrawer ? "fonMenuActive" : ""}`}>
        <img src={logo2} alt="" />
        <div className="sideMenuPlacer">
          <div className="fonMenuX" onClick={cnclFon}>
            <Icon className="faIcon" icon="solar:alt-arrow-right-linear" />
          </div>
          <div className="fonMenuLinks">
            <a href="/jobs">Job Opportunities</a>
            <a href="/dashboard">AI Tasks</a>
            <a href="/referral-program">Referral Program</a>
            <a href="/about">About Us</a>
            <button onClick={() => toAuth()}>Get Started</button>
          </div>
        </div>
      </div>
      <div className="jobsNav navContWhite">
        <Navbar />
      </div>

      <div className="jobsPlacer">
        <div className="jobLeftUi" ref={leftUI}>
          <div className="jobSearch">
            <div className="jobsIcon">
              <Icon className="faIcon" icon="solar:magnifer-linear" />
            </div>
            <div className="jobsSearchInput">
              <input
                type="text"
                placeholder="Search Job by name..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="jobsActCont">
            {!jobArray?.length ? (
              <p className="ljobsLoad">No available jobs</p>
            ) : filteredJobs.length === 0 ? (
              <p className="ljobsLoad">No jobs found matching "{searchTerm}"</p>
            ) : (
              filteredJobs.map((job, index) => (
                <div
                  className="actJob"
                  key={job.id || index}
                  onClick={() => viewJob(job.id)}
                >
                  <div className="actJobPlacer">
                    <div className="actJobTop">
                      <div className="jobIcon">
                        <img src={logo1} alt="" />
                      </div>
                      <div className="jobDet">
                        <div className="jobDetTit">
                          <h4>{job.jobName}</h4>
                        </div>
                        <div className="fidiProf">
                          <p>{job.jobminiTtile}</p>
                        </div>
                      </div>
                    </div>
                    <div className="actJobBtm">
                      <div className="jobDetdesc">
                        <p>{job.jobDesc}</p>
                      </div>
                      <div className="miniPriceandApplicants">
                        <div className="miniPrice">
                          <button>Apply</button>
                        </div>
                        <div className="miniApplicants">
                          <p>
                            <span>${job.jobPay}</span> / hour
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="jobRightUi" ref={rightUI}>
          {!SelectedJob ? (
            <>
              <img src={man} alt="" />
              <p>Select a job to preview</p>
            </>
          ) : (
            <>
              <div className="viewJob">
                <div className="viewJobTitle">
                  <div className="jobLogo">
                    <img src={logo1} alt="fav" />
                  </div>
                  <div className="vjt">
                    <span id="viewedTitle">{SelectedJob.jobName}</span>
                    <div className="vjth3">
                      <span>
                        <span id="viewedPrice">${SelectedJob.jobPay}</span> per hour
                      </span>
                      <p>
                        Required skill :{" "}
                        <span id="viewedSkill">{SelectedJob.jobminiTtile}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="projectOverview">
                  <p>Project Overview</p>
                  <p id="viewJobDesc">{SelectedJob.jobDesc}</p>
                </div>

                <div className="projectRequirements">
                  <p>Job Requirements</p>
                  <p id="viewedJobReq">{SelectedJob.jobReq}</p>
                </div>
              </div>
              <div className="viewJobBtn">
                <div className="backBtn" onClick={()=>backtoList()}>
                  <Icon className="faIcon" icon="solar:arrow-left-linear" />
                </div>
                <button onClick={() => applyJob()}>Apply Job</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Jobs;